import React, { Component } from "react";
import {
  withStyles,
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  Grid,
} from "@material-ui/core";
import Typography from '@material-ui/core/Typography';
import { styles } from "./metadata-popout.css.js";
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import PublicIcon from '@material-ui/icons/Public';
import CloseIcon from "@material-ui/icons/Close";
import SettingsApplicationsIcon from '@material-ui/icons/SettingsApplications';
import AspectRatioIcon from '@material-ui/icons/AspectRatio';

// import trackFields from "_module/definition/trackFields";
import { AuthSrc } from "util/AuthSrc";
import MusicNoteIcon from "@material-ui/icons/MusicNote";
import { connect } from "react-redux";
import Player from "../../../modules/ml-player/Player";
import {
  clearAudio,
  setPopoutFor,
} from "../../../redux/actions/PlayerActions";
import TrackPreview from "../../../modules/ml-music-search/track/Preview";
import AlbumTracksPreview from "../../../modules/ml-music-search/album-tracks/Preview";
import PlPreview from "../../../modules/ml-playlist/playlist/Preview";
import ClearanceTrackPreview from "../../../modules/ml-licensing/Tracks/Preview";
import ClearanceFormTrackPreView from "../../../modules/ml-licensing/clearance-form/Preview";
import MetadataPopupPlayer from "modules/ml-player/MetadataPopupPlayer.js";
import { PageTableType } from "redux/Types.js";
import CliIconMain from "images/artwork.png";
import NewWindow from "react-new-window";
import { PlaylistItemTypes } from "modules/ml-music-search/track/RecentPlaylistMenu.js";
class MetaDataPopOut extends Component {
  constructor(props) {
    super();
    this.state = {
      popOutOpen: false,
      openWindows: {}, // key: trackId, value: true/false
    };
  }

  // handleOpen = (e) => {
  //   this.setState({ popOutOpen: true });
  // };

  // Open a new popup for the specific track
  handleOpen = (trackId) => {
    // this.setState((prev) => ({
    //   openWindows: { ...prev.openWindows, [trackId]: { open: true, trackData: this.props.data } },
    // }));

    this.setState((prevState) => {
      // prevent opening same track twice
      if (prevState.openWindows[trackId]?.open) return prevState;

      return {
        openWindows: {
          ...prevState.openWindows,
          [trackId]: { open: true, trackData: this.props.data },
        },
      };
    });
  };

  // onClose = (e) => {
  //   this.setState({ popOutOpen: false });
  // }

  // Close a popup for the specific track
  onClose = (trackId) => {
    this.setState((prev) => {
      const updated = { ...prev.openWindows };
      delete updated[trackId];
      return { openWindows: updated };
    });
  };

  getPlayerContent = (pData) => {
    const {
      classes,
      data,
      popoutFor,
      player: { playObject, track, popoutFor: popoutForPrev },
      orgRuntime: {
        runtime: {
          _trackFields: trackFields,

        }
      },
      isInline
    } = this.props;

    let oData = pData || data;

    return (
      <>
        {/* <Grid item xs={2}>
          <div className={classes.imgContainer}>
            {((popoutFor || popoutForPrev) === PageTableType.CLEARANCE_TRACKS || (popoutFor || popoutForPrev) === PageTableType.CLEARANCE_FORM_TRACKS) && data.trackDetails && data.trackDetails[trackFields.prodArtworkUrl.id] ? 
            (
              <img
                style={{ height: 150, width: 150 }}
                src={AuthSrc(data.trackDetails[trackFields.prodArtworkUrl.id])}
                alt={data.trackDetails[trackFields.trackTitle.id] || ""}
              />
            )
            : 
            data[trackFields.prodArtworkUrl.id] ? (
              <img
                style={{ height: 130, width: 130 }}
                src={AuthSrc(data[trackFields.prodArtworkUrl.id])}
                alt={data[trackFields.trackTitle.id] || ""}
              />
            ) : (
              <Grid
                container
                direction="column"
                alignItems="center"
                justify="center"
                style={{ height: 150, width: 150 }}
              >
                <img className={"emptyArtwork"} style={{ width: 120 }} src={CliIconMain}  alt="Sky Music" />
              </Grid>
            )}
          </div>
          </Grid> */}

        <Grid item xs={9}>
          <div className={classes.innerPadding}>
            <div>
              <Typography className={classes.headTag} variant="h1" component="h2">
                {((popoutFor || popoutForPrev) === PageTableType.CLEARANCE_TRACKS || (popoutFor || popoutForPrev) === PageTableType.CLEARANCE_FORM_TRACKS) && oData.trackDetails && oData.trackDetails[trackFields.trackTitle.id] ? oData.trackDetails[trackFields.trackTitle.id] : 
                oData.pl_prop_type && oData.pl_prop_type ==  PlaylistItemTypes.album?  oData.prodName :
                oData[trackFields.trackTitle.id]}
              </Typography>

              <span className={classes.artistName} >
                {((popoutFor || popoutForPrev) === PageTableType.CLEARANCE_TRACKS || (popoutFor || popoutForPrev) === PageTableType.CLEARANCE_FORM_TRACKS) && oData.trackDetails && oData.trackDetails[trackFields.performer.id] ?
                  (oData.trackDetails[trackFields.performer.id] &&
                    Array.isArray(oData.trackDetails[trackFields.performer.id])
                    ? oData.trackDetails[trackFields.performer.id].join(", ")
                    : oData.trackDetails[trackFields.performer.id]) ||
                  ""
                  :
                  oData.pl_prop_type && oData.pl_prop_type ==  PlaylistItemTypes.album? oData.prodArtist :
                  (oData[trackFields.performer.id] &&
                    Array.isArray(oData[trackFields.performer.id])
                    ? oData[trackFields.performer.id].join(", ")
                    : oData[trackFields.performer.id]) ||
                  ""}
              </span>
            </div>

            {/* {track && track.id === data.id ?
              <div >
                <div className={classes.playerPopContainer}>{playObject && <Player isPopOut={true} />}</div>
              </div>
              :
              <div className={classes.playerPopContainer}>
                <MetadataPopupPlayer popoutFor={popoutFor || popoutForPrev} item={data.trackDetails ? data.trackDetails : data} />
              </div>
            } */}


          </div>
        </Grid>
      </>
    )
  }

  getPopoutContent = (pData) => {
    const {
      classes,
      data,
      popoutFor,
      player: { playObject, track, popoutFor: popoutForPrev },
      orgRuntime: {
        runtime: {
          _trackFields: trackFields,

        }
      },
      isInline
    } = this.props;

    let oData = pData || data;

    return (
      <>
        {!isInline && (
          <Grid container>
            {this.getPlayerContent(oData)}

            {/* <Grid item xs={1}>
              { !isInline && (
                <Button
                  aria-label="Close Popup"
                  title="Close Popup Window"
                  onClick={this.onClose}
                  className={classes.closeButton}
                >
                  <CloseIcon />
                </Button>
              ) }
            </Grid> */}

          </Grid>
        )}




        <div className={classes.dataViewContainer}>
          {(popoutFor || popoutForPrev) === PageTableType.SEARCH_TRACKS && (<TrackPreview playerContent={this.getPlayerContent(oData)} isInline={isInline} isPopOut={true} item={oData} />)}
          {(popoutFor || popoutForPrev) === PageTableType.SEARCH_ALBUM_TRACKS && (<AlbumTracksPreview isPopOut={true} item={oData} />)}
          {(popoutFor || popoutForPrev) === PageTableType.MYPLAYLIST_TRACKS && (<PlPreview isPopOut={true} item={oData} />)}
          {(popoutFor || popoutForPrev) === PageTableType.CLEARANCE_TRACKS && (<ClearanceTrackPreview isPopOut={true} item={oData} />)}
          {(popoutFor || popoutForPrev) === PageTableType.CLEARANCE_FORM_TRACKS && (<ClearanceFormTrackPreView isPopOut={true} item={oData} />)}
        </div>
      </>
    )
  }



  render() {
    const {
      classes,
      data,
      popoutFor,
      player: { playObject, track, popoutFor: popoutForPrev },
      orgRuntime: {
        runtime: {
          _trackFields: trackFields,

        }
      },
      isInline
    } = this.props;

    const {
      popOutOpen,
      ComparePopOutOpen,
      AutoCompare,
      ManualCompare,
      openWindows
    } = this.state;

    const trackId = data && data.pl_prop_type && data.pl_prop_type ==  PlaylistItemTypes.album ? data?.prodId : data[trackFields.id.id]; // unique ID per track
  

    return (
      <>
        {isInline && (
          <>
            {this.getPopoutContent()}
          </>
        )}
        {!isInline && (
          <Button
            aria-label="Open popup data"
            title="Open Popup "
            // className={classes.globalCreateAddButton}
            // onClick={this.handleOpen}
            onClick={() => this.handleOpen(trackId)}
            disabled={!data}
          >
            <OpenInNewIcon /> <span class="hideInside">Open in Popup</span>
          </Button>
        )}
        {Object.keys(openWindows).map((trackId) => {
          const popup = openWindows[trackId];
          if (!popup.open) return null;

          return (
            <NewWindow
              key={trackId}
              // title={`Track Metadata - ${data[trackFields.trackTitle.id] || data.trackDetails[trackFields.trackTitle.id] || ""}`}
              title={`Metadata - ${popup.trackData? 
                popup.trackData.pl_prop_type && popup.trackData.pl_prop_type ==  PlaylistItemTypes.album? 
                popup.trackData.prodName : 
                (popup.trackData?.trackTitle || popup.trackData?.trackDetails?.trackTitle) ? 
                popup.trackData[trackFields.trackTitle.id] || popup.trackData.trackDetails[trackFields.trackTitle.id] || "" : "" : ""}`}
              onUnload={() => this.onClose(trackId)}
              copyStyles={true}
              features={{
                width: window.screen.availWidth,
                height: window.screen.availHeight,
                left: 0,
                top: 0,
              }}
              onOpen={(popup) => {
                const favicon = popup.document.createElement("link");
                favicon.rel = "icon";
                favicon.type = "image/png";
                favicon.href = "/assets/sm/favicon.ico"; // your icon path
                // favicon.href = "https://img.icons8.com/?size=100&id=80449&format=png&color=000000"; // your icon path
                popup.document.head.appendChild(favicon);
              }}
            >
              {popup.trackData ?
                <div style={{ padding: 16 }}>
                  {this.getPopoutContent(popup.trackData && popup.trackData.trackDetails && (popoutFor || popoutForPrev) !== PageTableType.CLEARANCE_FORM_TRACKS ? popup.trackData.trackDetails : popup.trackData)}
                </div> :
                <div>No Data</div>
              }
            </NewWindow>
          );
        })}
        {/* <Dialog
          open={popOutOpen}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          // className={classes.dialogWrapper}                
          className={classes.modalPopupWrap}
        >

          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {this.getPopoutContent()}
            </DialogContentText>
          </DialogContent>
        </Dialog> */}
      </>
    );
  }

}


const mapStateToProps = (state) => ({
  player: state.player,
  orgRuntime: state.orgRuntime,
});


export default connect(
  mapStateToProps,
  {
    clearAudio,
    setPopoutFor,
  }
)(withStyles(styles)(MetaDataPopOut));
